import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { SOCIAL_PROOF_MESSAGES } from "./questions";

export const SocialProof = () => {
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    let active = true;
    const timeouts = [];
    const cycle = (delay) => {
      timeouts.push(
        setTimeout(() => {
          if (!active) return;
          setMsg(SOCIAL_PROOF_MESSAGES[Math.floor(Math.random() * SOCIAL_PROOF_MESSAGES.length)]);
          timeouts.push(
            setTimeout(() => {
              if (!active) return;
              setMsg(null);
              cycle(5500 + Math.random() * 5000);
            }, 4500)
          );
        }, delay)
      );
    };
    cycle(3500);
    return () => {
      active = false;
      timeouts.forEach(clearTimeout);
    };
  }, []);

  return (
    <div className="fixed bottom-4 left-4 z-[60] max-w-[290px] pointer-events-none">
      <AnimatePresence>
        {msg && (
          <motion.div
            data-testid="social-proof-toast"
            initial={{ opacity: 0, y: 24, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="flex items-center gap-2.5 rounded-full border border-pink-400 bg-white/85 px-4 py-3 shadow-[0_0_18px_rgba(236,72,153,0.35)] backdrop-blur-md"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-cyan-400 to-pink-500 text-white shadow-[0_0_10px_rgba(6,182,212,0.5)]">
              <Sparkles size={14} />
            </span>
            <p className="text-xs font-bold leading-snug text-slate-800">{msg}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
